import localizationEnUsEmployeesHeader from "./en-us/header.json";
import localizationEnUsEmployeesTable from "./en-us/table.json";
import localizationEnUsEmployeesModal from "./en-us/modal.json";

export const localizationEnUsEmployees = {
  ...localizationEnUsEmployeesHeader,
  ...localizationEnUsEmployeesModal,
  ...localizationEnUsEmployeesTable,
};
